const today = new Date();
const format1 = `${today.getDate().toString().padStart(2, '0')}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getFullYear()}`;
const format2 = `${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}-${today.getFullYear()}`;
const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

function getOrdinalNum(n) {
  return n + (n > 0 ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10] : '');
}

const format3 = `${monthNames[today.getMonth()]} ${getOrdinalNum(today.getDate())} ${today.getFullYear()}`;

export default [
  {
    label: `${format1} (DD-MM-YYYY)`,
    value: "DD-MM-YYYY"
  },
  {
    label: `${format2} (MM-DD-YYYY)`,
    value: "MM-DD-YYYY"
  },
  {
    label: `${format3} (MMMM Do YYYY)`,
    value: "MMMM Do YYYY"
  }
];